import type { PositionOption, ReturnOrderLine, ReturnOrderLineView, ReturnSerialRow } from "../types";
import { normalizeSerial } from "../utils/serial";

/** Dòng đơn đổi trả của một serial. Mỗi dòng hàng trả mang một serial (ATTRIBUTE13), backend so khớp theo serial */
export const findOrderLineBySerial = (lines: ReturnOrderLine[], serial: string | null | undefined) => {
  const key = normalizeSerial(serial);
  return key ? lines.find((line) => normalizeSerial(line.serial) === key) : undefined;
};

/** Số đã quét của từng dòng đơn = tổng số lượng các serial trùng serial của dòng (như trang cũ) */
export const buildOrderLineView = (lines: ReturnOrderLine[], rows: ReturnSerialRow[]): ReturnOrderLineView[] => {
  const scanned = new Map<string, number>();
  rows.forEach((row) => {
    const key = normalizeSerial(row.serial);
    if (key) scanned.set(key, (scanned.get(key) ?? 0) + (Number(row.primaryQuantity) || 0));
  });
  return lines.map((line) => ({ ...line, scannedQuantity: scanned.get(normalizeSerial(line.serial)) ?? 0 }));
};

/** Tổng số lượng các serial trên phiếu */
export const totalScannedQuantity = (rows: ReturnSerialRow[]) =>
  rows.reduce((sum, row) => sum + (Number(row.primaryQuantity) || 0), 0);

/** Số dòng đơn còn thiếu sau khi quét, cho dòng trạng thái cạnh ô quét */
export const missingQuantityOf = (lines: ReturnOrderLineView[]) =>
  lines.reduce((sum, line) => sum + Math.max(0, (Number(line.primaryQuantity) || 0) - line.scannedQuantity), 0);

/** Vị trí theo id; id gửi lên dạng số nhưng phiếu cũ có thể trả chuỗi */
export const findPosition = (positions: PositionOption[], id: string | number | null | undefined) =>
  id == null || id === "" ? undefined : positions.find((position) => String(position.id) === String(id));
